import api from "@/request/api"
import { devhost } from "@/request/request"


export async function handlerCheckUnionIsOnline({domain}) {
    let paramsConfig = window.UnionDomainParam || {
      ck: "chengkao",
      fakao: "sf",
      jjxs: "jjcy",
      gongzhao: "jszp",
    };
    let pageDomain = (paramsConfig[domain] || domain)
    const { data } = await api.handlerCheckUnionIsOnline({
        domain: pageDomain,
      });
      console.log(data);
      if (process.env.NODE_ENV === "development") {
        console.log("localhost");
        setTimeout(() => {
          location.href = "http://" + devhost + "/" + pageDomain
        }, 5000);
      } else {
        if (data == 1) {
          // 跳转新的联盟页面
          location.href = location.origin + "/" + pageDomain;
          return Promise.reject("jump new location");
        }
      }
}